export enum AnalyticsEvent {
  MainPageOpened,

  LogParsed,
  LogDecompressed,

  OpenAsTextClicked,
  DownloadAsTextClicked,

  BookmarkAdded,
  BookmarkRemoved,

  SearchTermChanged,
  FilterTermChanged,

  CloseSuggestionToUseChrome,

  JsonCopyJqPath,
  JsonCopyJsonValue,
  JsonExtractJqColumn,

  TimelineShown,
  TimelineHidden,
  TimelineClickOnMarker,
}
